import { t } from '../../modules/i18n';

export const formatDeviceTitle = brand => {
  const it18nKey = `device.${brand}`;
  const i18nValue = t(it18nKey);
  if (i18nValue && i18nValue !== it18nKey) {
    return i18nValue;
  }

  return brand;
};
